import React from "react";
import { Grid } from "@mui/material";
import { SearchTextParamName } from "types";
import { FilterRow, FilterWrapper } from "components";
import { EmployeeFilter } from "modules/shared/filters/EmployeeFilter";
import { SearchTextFilter } from "modules/shared/filters/SearchTextFilter";

export const TaskTypeListFilter: React.FC = () => (
  <FilterWrapper>
    <FilterRow>
      <Grid item>
        <EmployeeFilter />
      </Grid>
      <Grid item>
        <SearchTextFilter
          searchTextParamName={SearchTextParamName.SearchTaskType}
        />
      </Grid>
    </FilterRow>
  </FilterWrapper>
);
